<template>
  <section>
    <!-- search -->
    <form @submit.prevent="loadData">
      <div class="section_search">
        <div class="tray">
          <div class="row">
            <div class="cell">
              <select class="selectBox" style="display:inline-block;width:100px;" v-model="formData.range">
                <option value="DAILY">일간</option>
                <option value="WEEKLY">주간</option>
                <option value="MONTHLY">월간</option>
                <option value="QUARTERLY">분기</option>
              </select>

              <!-- 일간 -->
              <DatePicker v-if="formData.range === 'DAILY'" :value="$utils.calcDate(null, '-1d')" class="blank" ref="picker" :maxDate="new Date()"/>
              <WeekPicker v-if="formData.range === 'WEEKLY'" class="blank" width="300px" ref="picker" :maxDate="new Date()"/>
              <MonthPicker v-if="formData.range === 'MONTHLY'" class="blank" ref="picker" :maxDate="new Date()"/>
              <QuarterPicker v-if="formData.range === 'QUARTERLY'" class="blank" ref="picker" :maxDate="new Date()"/>
            </div>
            <span class="label">지역</span>
            <div class="cell">
              <GroupSelector
              permissionCode="statistic"
              :useGroup="false"
              ref="groupSelector"
              />
              <button type="submit" class="btn_search">검색</button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- //search -->

    <template v-if="res">
      <h4 class="section_title">
        <span class="ico"></span>게임 유형별 통계
        <p class="desc"><strong>등록된 대상자수</strong> : {{res.userCount}}명</p>
      </h4>

      <PlainTable :sourceList="gameTypeList">
        <template #header>
          <caption><span class="blind">개임 유형별 통계</span></caption>
          <colgroup>
            <col>
            <col width="15%">
            <col width="15%">
            <col width="15%">
            <col width="15%">
          </colgroup>

          <thead class="table_list_head">
          <tr>
            <th>게임 유형</th>
            <th>요청건수</th>
            <th>요청한 대상자수</th>
            <th>완료건수(유형단위)</th>
            <th>완료한 대상자수</th>
          </tr>
          </thead>
        </template>
        <template #row="{rowData}">
          <tr :class="{row_line: rowData._divFlag}">
            <td>{{rowData.gameType}}<span v-if="rowData.gameType.trim() === '객관식유형'" class="important">*</span></td>
            <td class="right">{{rowData.requestCount}}</td>
            <td class="right">{{rowData.requestUserCount}}</td>
            <td class="right">{{rowData.completeCount}}</td>
            <td class="right">{{rowData.completeUserCount}}</td>
          </tr>
        </template>
      </PlainTable>

      <p class="table_data_desc"><span class="dot">*</span> 객관식 유형 : 공통점 찾기, 어울리는 단어 찾기, 넌센스 퀴즈, 연상 퀴즈, 나도야 시인, 다른 종류 고르기</p>
    </template>

    <template v-if="res">
      <div class="section_title">
        <span class="ico"></span>평균점수별 대상자수
        <p class="desc">※ 게임을 3개 이상 수행한 대상자에 대해서 집계함</p>
      </div>

      <PlainTable :sourceList="reversedGameAvgCount.slice(0, 1)">
        <template #header>
          <caption><span class="blind">평균점수별 대상자수</span></caption>
          <colgroup>
            <col>
            <col width="15%">
            <col width="15%">
            <col width="15%">
            <col width="15%">
            <col width="15%">
          </colgroup>

          <thead class="table_list_head table_list_head_line">
          <tr>
            <th>평균점수</th>
            <th>20미만</th>
            <th>20이상</th>
            <th>40이상</th>
            <th>60이상</th>
            <th>80이상</th>
          </tr>
          </thead>
        </template>
        <template #row="{rowData}">
          <tr>
            <td class="right">{{rowData.date}}</td>
            <td class="right">{{rowData.score20}}</td>
            <td class="right">{{rowData.score40}}</td>
            <td class="right">{{rowData.score60}}</td>
            <td class="right">{{rowData.score80}}</td>
            <td class="right">{{rowData.score100}}</td>
          </tr>
        </template>
      </PlainTable>
    </template>
    <div class="section_button none_paginate">
      <button type="button" class="btn_detail" @click="onClickDetail">날짜별 전체보기</button>
    </div>
  </section>
</template>

<script>
  import mixin from './_mixin'
  import DetailPopup from './popups/BrainAverageDetail'

  export default {
    mixins: [ mixin ],
    data() {
      return {
        res: null,
        resPeriod: '',
        formData: {
          range: 'WEEKLY',
          state: '', city: '',
        }
      }
    },
    computed: {
      gameTypeList() {
        if (!this.res || !this.res.gameTypeStat) return []
        const data1 = this.res.gameTypeStat.data1
        const data2 = this.res.gameTypeStat.data2
        if (data2 && data2.length) data2[0]._divFlag = true
        return data1.concat(data2)
      },
      reversedGameAvgCount() {
        if (!this.res) return []
        return this.res.gameAvgCount.reverse()
      }
    },
    methods: {
      loadData() {
        const options = this.requestOptions()
        this.$axios.get('/admin/happy/stats/game', options).then(({data}) => {
          this.res = data

          // 요청한 기간 저장
          if (this.formData.range === 'DAILY') this.resPeriod = this.$utils.dateformat(this.$refs.picker.getDate(), 'yyyy-mm-dd')
          else {
            const pickerData = this.$refs.picker.getData()
            this.resPeriod = `${this.$utils.dateformat(pickerData.startDate, 'yyyy-mm-dd')} ~ ${this.$utils.dateformat(pickerData.endDate, 'yyyy-mm-dd')}`
          }
        })
      },
      requestOptions() {
        const group = this.$refs.groupSelector.getData()
        const startDate = this.$refs.picker.getDate()

        return { params: _.merge(this.formData, {
          searchDate: this.$utils.dateformat(startDate, 'yyyy-mm-dd'),
          orgCode: group.orgId,
          state: group.stateId,
          city: group.cityId,
        })}
      },
      onClickDetail() {
        const avgData = this.reversedGameAvgCount
        this.openPopup(DetailPopup, {avgData, period: this.resPeriod})
      },
    },
    mounted() {
      this.loadData()
    }
  }
</script>
